<ng-template #notificationTemplate let-data="data">
  <div class="ant-notification-notice-content ant-notification-notice-with-icon">
    <span nz-icon nzType="info-circle" class="ant-notification-notice-icon ant-notification-notice-icon-info"></span>
    <div class="ant-notification-notice-message">{{data.message}}</div>
    <div class="ant-notification-notice-description">{{data.quoteIdentifier}}</div>
    <div class="ant-notification-notice-btn" *ngIf="data.quoteUrl">
      <button nz-button nzType="primary" nzSize="small" type="button"
              [disabled]="data.opened" (click)="data.openQuote($event)">Open quote</button>
    </div>
  </div>
</ng-template>
